import { icons } from '../components/Icons';
import { CustomPaper } from '../components/Layout/CustomPaper';
import { authClient } from '../lib/authClient';
import { trpc } from '../lib/trpc';
import { routes } from '../routes';
import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
// import { AirbrakeContext } from '../withAirbrake';
import {
  Alert,
  Anchor,
  Button,
  Checkbox,
  PasswordInput,
  Space,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { CircleX } from 'lucide-react';
import { use } from 'react';
// import * as icons from '../components/Icons';
// import LogRocket from 'logrocket';
import { useForm } from 'react-hook-form';
import { Link, useLocation } from 'wouter';
import { z } from 'zod/v4';

const schema = z.object({
  email: z.email().min(1, 'A valid email address is required'),
  name: z.string().min(1, 'Name is required'),
  options: z.object({
    agreeToEmails: z.boolean(),
    agreeToTos: z.literal(true, {
      error: () => ({ message: 'You must agree to TOS' }),
    }),
    // .configure({
    //   message: 'You must agree to the terms of service',
    // }),
  }),
  password: z.string().min(1, 'Password is required'),
  passwordConfirmation: z.string().min(1, 'Password confirmation is required'),
});

export const Signup: React.FC = () => {
  // const context = useContext(SupabaseContext);
  // const { user } = useUser();
  // const airbrake = useContext(AirbrakeContext);

  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
    setError,
  } = useForm<z.infer<typeof schema>>({
    resolver: standardSchemaResolver(schema),
  });
  // <{
  //   email: string;
  //   options: {
  //     data: {
  //       agreeToEmails: boolean;
  //       agreeToTos: boolean;
  //     };
  //   };
  //   password: string;
  //   passwordConfirmation: string;
  // }>();

  const [, navigate] = useLocation();

  // useEffect(() => {
  //   if (user) {
  //     navigate(routes.home, { replace: true });
  //   }
  // }, [navigate, user]);

  // const submitHandler = handleSubmit(async (userData) => {
  //   if (!context) {
  //     return;
  //   }

  //   if (userData.password !== userData.passwordConfirmation) {
  //     setError('passwordConfirmation', {
  //       message: 'Passwords do not match',
  //     });
  //     return;
  //   }

  //   const { data, error } = await context.supabase.auth.signUp(userData);
  //   debug('Sign up response:', { data, error });
  //   if (error) {
  //     LogRocket.captureMessage(error.message);
  //     airbrake?.notify(error);
  //     showNotification({
  //       ...icons.failure,
  //       message: 'An error occurred. Please try again later.',
  //     });
  //   } else {
  //     showNotification({
  //       ...icons.success,
  //       message:
  //         'Account created. Please check your inbox for the confirmation e-mail.',
  //     });
  //     navigate(routes.signIn, {
  //       replace: true,
  //     });
  //   }
  // });

  const features = use(
    trpc.features.list.useQuery(undefined, {
      experimental_prefetchInRender: true,
    }).promise,
  );

  if (features['new_sign_ups']) {
    const submitHandler = handleSubmit(async (formData) => {
      if (formData.password !== formData.passwordConfirmation) {
        setError('passwordConfirmation', {
          message: 'Passwords do not match',
        });
        return;
      }

      const { error } = await authClient.signUp.email({
        email: formData.email,
        name: formData.name,
        password: formData.password,
      });

      if (error) {
        setError('root', {
          message: error.message,
        });
      } else {
        notifications.show({
          message: (
            <>
              <icons.Success /> Sign up successful!
            </>
          ),
        });
        navigate(routes.home);
      }
    });

    return (
      <CustomPaper>
        <Title order={3}>Sign up</Title>
        <Space h="sm" />
        {errors.root && (
          <>
            <Alert
              color="red"
              icon={<CircleX />}
              variant="filled"
            >
              {errors.root.message}
            </Alert>
            <Space h="sm" />
          </>
        )}
        <form
          noValidate
          onSubmit={submitHandler}
        >
          <TextInput
            error={errors?.email?.message?.toString()}
            label="Email address"
            required
            type="email"
            {...register('email')}
          />
          <Space h="md" />
          <TextInput
            error={errors?.name?.message?.toString()}
            label="Name"
            required
            {...register('name')}
          />
          <Space h="md" />
          <PasswordInput
            error={errors?.password?.message?.toString()}
            label="Password"
            required
            {...register('password')}
          />
          <Space h="md" />
          <PasswordInput
            error={errors?.passwordConfirmation?.message?.toString()}
            label="Password Confirmation"
            required
            {...register('passwordConfirmation', {
              required: 'Please provide a password confirmation',
            })}
          />
          <Space h="xl" />
          <Checkbox
            error={errors?.options?.agreeToTos?.message?.toString()}
            required
            {...register('options.agreeToTos', {
              required: 'You must agree to the terms of service',
            })}
            label={
              <Text size="sm">
                I agree to the{' '}
                <a
                  href="https://clew.app/tos/"
                  rel="noreferrer"
                  target="_blank"
                >
                  Terms of Service
                </a>{' '}
                <span className="text-(--mantine-color-red-6)">*</span>
              </Text>
            }
          />
          <Space h="xl" />
          <Checkbox
            label="I agree to receive occasional emails from Clew"
            {...register('options.agreeToEmails')}
          />
          <Space h="xl" />
          <Button
            disabled={isSubmitting}
            loading={isSubmitting}
            type="submit"
          >
            Sign up
          </Button>
        </form>
        <Space h="xl" />
        <Anchor
          component={Link}
          to={routes.signIn}
        >
          Sign in
        </Anchor>
      </CustomPaper>
    );
  }

  return (
    <CustomPaper>
      <div className="text-center">
        Sign ups are currently not available.
        <br />
        Please try again later 🙏
        <Space h="xl" />
        <Anchor
          component={Link}
          to={routes.signIn}
        >
          Sign in
        </Anchor>
      </div>
    </CustomPaper>
  );
};
